import { render, staticRenderFns } from "./SortTableHeader.vue?vue&type=template&id=c64a4bf4&"
import script from "./SortTableHeader.vue?vue&type=script&lang=js&"
export * from "./SortTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports